/**
 * This is lazy loading config that initiate when open the webpage
 * DON'T import any module here. Ohterwise, the module will be loaded and lost the lazy loading.
 * */
import React from 'react';
import { withAsync } from '../../components/lazyLoading/async-component';
import { withPNHoc } from '../../hoc/policyNumber/withPNHoc';
import axagoalSaga from '../../modules/axagoal/sagas';

const MODULE_FOLDER_NAME = 'axagoal'; // Folder name of the module for lazy import
const MODULE_NAME = 'hk-emma-web-module-axagoal'; // Module name from package.json
const ROOT_PATHS = [
  // Root path of the routes
  'marketplace/myprivileges/axagoal',
  'home/life/axagoal',
];

export default {
  preloadModules: [
    {
      preloadSagas: [axagoalSaga],
    },
  ],
  modules: [
    {
      moduleName: MODULE_NAME,
      routes: {
        rootPaths: ROOT_PATHS,
        subPaths: {
          '/summary/:id/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(MODULE_FOLDER_NAME, '/summary/:id/:entityCode'),
            ),
          },
          '/summary/:id/:entityCode/:membershipYear': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(
                MODULE_FOLDER_NAME,
                '/summary/:id/:entityCode/:membershipYear',
              ),
            ),
          },
          '/summary-:ruleType/:id/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(MODULE_FOLDER_NAME, '/summary-:ruleType/:id/:entityCode'),
            ),
          },
          '/rules/': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/rules/'),
          },
          '/rules/wgp': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/rules/wgp'),
          },
          '/rules/sh': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/rules/sh'),
          },
          '/rules/both': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/rules/both'),
          },
          '/membership/:id/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(MODULE_FOLDER_NAME, '/membership/:id/:entityCode'),
            ),
          },
          '/recode/:month/:achieveDays/:entityCode/:ruleType': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/recode/:month/:achieveDays/:entityCode/:ruleType',
            ),
          },
          '/recode/:month/:achieveDays': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/recode/:month/:achieveDays',
            ),
          },
          '/dashboard': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/dashboard'),
          },
          '/seeAllPolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/seeAllPolicy'),
          },
          '/support/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: () =>
              React.createElement(
                withAsync(MODULE_FOLDER_NAME, '/support/:entityCode'),
                { type: 'axa-goal' },
              ),
          },
          '/support-WGP/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: () =>
              React.createElement(
                withAsync(MODULE_FOLDER_NAME, '/support-WGP/:entityCode'),
                { type: 'axa-goal', ruleType: 'WGP' },
              ),
          },
          '/support-SH/:entityCode': {
            exact: true,
            enableMobileRoute: true,
            container: () =>
              React.createElement(
                withAsync(MODULE_FOLDER_NAME, '/support-SH/:entityCode'),
                { type: 'axa-goal', ruleType: 'SH' },
              ),
          },
          '/support': {
            exact: true,
            enableMobileRoute: true,
            container: () =>
              React.createElement(withAsync(MODULE_FOLDER_NAME, '/support'), {
                type: 'axa-goal',
              }),
          },
        },
      },
    },
  ],
};
